import InlineData from './InlineData';

export default InlineData;
